import { FC, memo, HTMLAttributes, useCallback } from 'react';
import cn from 'classnames';

import * as ModalWindows from '@Stores/ModalWindows';
import Button from '@UI/Button';
import BackgroundImage from '@UI/BackgroundImage';
import bannerImage from './images/image.jpg';
import styles from './MainBanner.module.css';

interface MainBannerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const MainBanner: FC<MainBannerProps> = (props) => {
  const { className, ...restProps } = props;

  const handleClickButton = useCallback(() => {
    ModalWindows.open('VideoConsultation');
  }, []);

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <div className={styles.title}>Видеоконсультация со специалистом</div>
          <div className={styles.description}>
            Персональные видеоконсультации со специалистом магазина позволят выбрать мебель не
            выходя из дома.
          </div>
          <Button theme='primary' className={styles.button} onClick={handleClickButton}>
            Отправить заявку
          </Button>
        </div>
      </div>
      <BackgroundImage className={styles.image} src={bannerImage} />
    </div>
  );
};

export default memo(MainBanner);
